"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var T = _interopRequireWildcard(require("prop-types"));
var _AuButton = _interopRequireWildcard(require("../AuButton"));
var _copyTextToClipboard = _interopRequireDefault(require("../../../utils/copyTextToClipboard"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "dynamic_data_table-module__container___XBKGO",
  "table": "dynamic_data_table-module__table___KPe4Z",
  "header": "dynamic_data_table-module__header___InOJk",
  "hidden_scroll": "dynamic_data_table-module__hidden_scroll___smZMg",
  "cell": "dynamic_data_table-module__cell___WmECs",
  "title": "dynamic_data_table-module__title___xRq1r",
  "body": "dynamic_data_table-module__body____WpZz",
  "wrapper": "dynamic_data_table-module__wrapper___6vpz9",
  "inner": "dynamic_data_table-module__inner___DWRAj",
  "row": "dynamic_data_table-module__row___mJOCH",
  "even": "dynamic_data_table-module__even___s9yJX dynamic_data_table-module__row___mJOCH",
  "odd": "dynamic_data_table-module__odd___QReWF dynamic_data_table-module__row___mJOCH",
  "sortable": "dynamic_data_table-module__sortable___y8wPA",
  "no_wrap": "dynamic_data_table-module__no_wrap___hv7Wl",
  "custom_no_data": "dynamic_data_table-module__custom_no_data___qSxqC",
  "msg": "dynamic_data_table-module__msg___dAka6",
  "msg_icon": "dynamic_data_table-module__msg_icon___CBpqN",
  "no_rows": "dynamic_data_table-module__no_rows___DABRw dynamic_data_table-module__msg___dAka6",
  "fetching": "dynamic_data_table-module__fetching___Udqx5 dynamic_data_table-module__msg___dAka6",
  "ellipsis": "dynamic_data_table-module__ellipsis___GMwo_",
  "highlight": "dynamic_data_table-module__highlight___VP4U1",
  "actions": "dynamic_data_table-module__actions___geMKG",
  "tooltip": "dynamic_data_table-module__tooltip___iNmbQ",
  "copy": "dynamic_data_table-module__copy___ua22X"
};
const Tooltip = props => {
  const [copied, setCopied] = (0, _react.useState)(false);
  const timeoutRef = (0, _react.useRef)();
  const handleCopy = (0, _react.useCallback)(async () => {
    (0, _copyTextToClipboard.default)(props.data);
    setCopied(true);
    await new _promise.default(res => {
      timeoutRef.current = (0, _setTimeout2.default)(res, 2000);
    });
    setCopied(false);
  }, [props.data]);
  (0, _react.useEffect)(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
    className: styles.tooltip,
    style: props.style
  }, props.children, /*#__PURE__*/_react.default.createElement(_AuButton.default, {
    size: _AuButton.BUTTON_SIZE_MEDIUM,
    type: _AuButton.BUTTON_TYPE_PLAIN,
    disabled: copied,
    className: styles.copy,
    displayId: copied ? 'au.copied' : 'au.copy',
    onClick: handleCopy
  })), props.containerRef);
};
Tooltip.propTypes = {
  containerRef: T.shape({
    current: T.object
  }).isRequired,
  data: T.string.isRequired,
  style: T.shape({
    top: T.number,
    left: T.number
  })
};
var _default = exports.default = Tooltip;